import React from 'react'
import { translate } from '../internationalization'
import { NewChat } from '../new-chat'
import wrench from './images/wrench.svg'

interface OwnState {
  hasError: boolean,
}

interface Props {
  children: React.ReactNode
}

class ErrorBoundary extends React.Component<Props, OwnState> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error) {
    // this method us used to show a reserved UI
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // this method can save error and its info to some journal
    console.error('Caught by ErrorBoundary:', error, errorInfo)
  }


  render() {
    if (this.state.hasError) {
      return <div className='fixed top-2/5 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center px-[10%] sm:px-[5%]'>
        <img className='w-2/5 max-w-[300px] inline-block mx-auto mb-10 align-middle' src={wrench} alt='Something went wrong' />
        <h1 className=' font-semibold mb-1'>{translate('Oops! Something went wrong.')}</h1>
        <h3 className='font-normal mb-6'>{translate('Please try refreshing the page or check back later.')}</h3>
        <NewChat label={translate('Start a new chat')} />
      </div>
    }

    return this.props.children
  }
}

export default ErrorBoundary